<template>
  <section
    class="overlay__content-section">
    <section
      :aria-expanded="!blockClosed"
      :aria-label="sectionAriaLabel"
      :class="stateClass"
      data-collapsible-block
      :data-collapsible-block-name="blockName"
      >
      <button
        class="icon-link"
        :aria-expanded="!blockClosed"
        @click.prevent="toggleOpenClose"
        v-html="displayTitle"
      />
      <div class="main-content">
        <slot></slot>
      </div>
    </section>
  </section>
</template>

<script>
  import { addSvgToEnd } from 'Helpers/embedSVG';

  export default {
    data: function() {
      return {
        blockClosed: true,
      }
    },

    props: {
      ariaLabel: { type: String, required: true },
      blockName: { type: String, required: true },
      title: { type: String, required: true },
      buttonClass: {type: String, default: "icon-link__text--body"},
    },

    computed: {
      displayTitle() {
        let icon = "icon-link__svg--270";
        if (this.blockClosed) {
          icon = "icon-link__svg--90";
        }
        return addSvgToEnd(this.title, this.buttonClass, "icon__caret--16--stroke.svg", `icon-link__svg ${icon}`);
      },

      stateClass() {
        if (this.blockClosed) {
          return "collapsible-block collapsible-block--closed";
        }
        return "collapsible-block collapsible-block--open";
      },

      sectionAriaLabel() {
        return `Open ${this.ariaLabel}`;
      }
    },

    methods: {
      toggleOpenClose() {
        this.blockClosed = !this.blockClosed;
        this.$el.getElementsByTagName("button")[0].focus();
      },
    }
  }

</script>
